import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { c } from 'ttag';

import { useConsent } from '@freelancelabs/components';
import { LogoFreelance } from '@freelancelabs/icons';

import { PublicRoutes } from '../../constants';
import LanguageSwitcher from '../components/LanguageSwitcher';
import LoginAnimation from './LoginAnimation';
import LoginClaim from './LoginClaim';

interface Props {
    children: ReactNode;
}

const PublicLayout = ({ children }: Props) => {
    const { openConsent } = useConsent();
    return (
        <div className="public-layout h-full min-w-full flex-nowrap grid md:grid-cols-2">
            <div className="relative flex flex-col px-4 md:px-6">
                <header className="container flex justify-end items-center h-16">
                    <span className="absolute top-[26px] left-[32px]">
                        <LogoFreelance size={104} />
                    </span>
                    {/* Not a duplicate: the aside is hidden below 900px, so this switcher is the
                        only one on small screens. The two are never visible together. */}
                    <span className="md:hidden">
                        <LanguageSwitcher />
                    </span>
                </header>
                <main className="flex flex-1 md:items-center justify-center py-6">
                    <section className="md:max-w-md flex-1 flex flex-col md:rounded-2xl">{children}</section>
                </main>
                <div className="h-16 flex items-center justify-center gap-[18px]">
                    <Link className="link link-weak" to={PublicRoutes.CGU}>
                        {c('Link').t`Legal notice`}
                    </Link>
                    {openConsent && (
                        <span className="link link-weak cursor-pointer" onClick={openConsent}>
                            {c('Link').t`Cookies parameters`}
                        </span>
                    )}
                </div>
            </div>
            <aside className="relative hidden md:flex items-center justify-center overflow-hidden">
                <span className="absolute top-[26px] right-[32px] z-10">
                    <LanguageSwitcher category="inverse" />
                </span>
                {/* The column, not the aside, carries the width so the animation keeps its native size. */}
                <div className="flex w-[560px] max-w-full flex-col">
                    <LoginAnimation />
                    <LoginClaim />
                </div>
            </aside>
        </div>
    );
};

export default PublicLayout;
